/* Approved family ratings only. No catalog download, app, third-party call, or persistent score cache. */
(() => {
  'use strict';
  const path = 'M10 1 12.8 6.7 19 7.6 14.5 12 15.6 18.2 10 15.3 4.4 18.2 5.5 12 1 7.6 7.2 6.7Z';
  const selectors = [
    '.ho-product-card', '.fm-card[data-fm-product]', '.n-card',
    '.afd-related > a', '.accessory-related', '.related-product', '.accessory-card', '.similar-card',
    '.n-series-grid article', '.product-card', '.brand-product-card',
    '.bromic-stack', '.bromic-overview-card', '#ho-products .piece', '#ho-hotspot .piece',
    '[data-kitchen-results] > article .ho-product-card', '.hx27-similar-item',
    '.hx27-addon', '.nap-related-card', '.accessory-grid > button', '.afd-accessory',
    '.finishing-card', '.space-project-item', '.ho-kitchen-item',
    'thead th:has(a[href*="/products/"])',
    '[data-category-selection][data-mode="compare"] th:has(a[href*="/products/"])'
  ].join(',');
  const records = new Map(), requests = new Map(), pending = [], hosts = new Set();
  let active = 0, frame = 0;
  const number = v => v === '' || v == null ? null : Number(v);
  function clean(d) {
    const market = number(d.market), count = Number(d.count), hop = number(d.hop);
    return {
      handle: d.handle,
      commerce: d.commerce || null,
      market: Number.isFinite(market) && market >= 0 && market <= 5 && Number.isInteger(count) && count >= 2 ? market : null,
      count,
      hop: Number.isFinite(hop) && hop >= 0 && hop <= 10 ? hop : null
    };
  }
  function handleOf(host) {
    const explicit = host.dataset.familyHandle;
    if (explicit) return explicit;
    const productUrl = host.dataset.hopProductUrl;
    if (productUrl) { try { return new URL(productUrl, location.href).pathname.match(/\/products\/([^/]+)/)?.[1] || ''; } catch { return ''; } }
    const link = host.matches('a[href]') ? host : host.querySelector('a[href*="/products/"]');
    if (!link) return host.matches('.related-product') ? optionData?.__titles?.[host.querySelector('h3')?.textContent.trim().toLowerCase()] || '' : '';
    try {
      const url = new URL(link.getAttribute('href'), location.origin);
      if (url.origin !== location.origin) return '';
      return decodeURIComponent(url.pathname.match(/\/products\/([^/]+)/)?.[1] || '');
    } catch { return ''; }
  }
  function readSlot(slot) {
    const d = clean(slot.dataset);
    if (d.handle && records.has(d.handle)) return records.get(d.handle);
    // Static brand cards can contain stale empty slots. Resolve those from the product endpoint.
    if (d.handle && (d.market !== null || d.hop !== null)) records.set(d.handle, d);
    return d;
  }
  document.querySelectorAll('[data-hop-rating-registry]').forEach(script => {
    try { JSON.parse(script.textContent).forEach(d => records.set(d.handle, clean(d))); } catch { /* fail closed */ }
  });
  document.querySelectorAll('[data-hop-rating]').forEach(readSlot);
  function stars(score) {
    const wrap = document.createElement('span');
    wrap.className = 'hop-card-stars'; wrap.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 5; i++) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 20 20'); svg.setAttribute('focusable', 'false');
      for (const [cls, fill] of [['hop-card-star-base', false], ['hop-card-star-fill', true]]) {
        const p = document.createElementNS(svg.namespaceURI, 'path');
        p.setAttribute('d', path); p.setAttribute('class', cls);
        if (fill) p.style.clipPath = 'inset(0 ' + (100 - Math.max(0, Math.min(1, score - i)) * 100) + '% 0 0)';
        svg.append(p);
      }
      wrap.append(svg);
    }
    return wrap;
  }
  function span(cls, text) {
    const n = document.createElement('span'); n.className = cls; n.textContent = text; return n;
  }
  function paint(slot, record, compare) {
    const d = clean(record);
    slot.replaceChildren();
    slot.classList.toggle('hop-card-rating--compare', compare);
    slot.removeAttribute('aria-hidden');
    const market = span('hop-card-market', '');
    if (d.market !== null) {
      market.setAttribute('aria-label', 'Market Rating ' + d.market.toFixed(1) + ' out of 5 from ' + d.count + ' eligible ratings');
      if (compare) market.append(span('hop-card-label', 'Market Rating'));
      market.append(stars(d.market), span('hop-card-number', d.market.toFixed(1) + '/5 (' + d.count + ')'));
    } else { market.setAttribute('aria-hidden', 'true'); market.classList.add('hop-card-empty'); }
    slot.append(market);
    if (compare) {
      const hop = span('hop-card-research', '');
      if (d.hop !== null) hop.append(span('hop-card-label', 'Hearth Outpost Score'), span('hop-card-number', d.hop.toFixed(1) + '/10'));
      else { hop.classList.add('hop-card-empty'); hop.setAttribute('aria-hidden', 'true'); }
      slot.append(hop);
    }
    if (d.market === null && (!compare || d.hop === null)) slot.setAttribute('aria-hidden', 'true');
    slot.dataset.loaded = 'true';
  }
  async function drain() {
    while (active < 2 && pending.length) {
      const {handle, resolve} = pending.shift(); active++;
      (async () => {
        try {
          const base = window.Shopify?.routes?.root || '/';
          const url = new URL(base + 'products/' + encodeURIComponent(handle), location.origin);
          url.searchParams.set('view', 'hop-card-rating');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(8000)});
          if (!response.ok) throw new Error('Rating summary unavailable');
          const data = clean(await response.json());
          if (data.handle !== handle) {
            const destination = new URL(response.url);
            const canonicalHandle = decodeURIComponent(destination.pathname.match(/\/products\/([^/]+)$/)?.[1] || '');
            if (!response.redirected || destination.origin !== location.origin || canonicalHandle !== data.handle) throw new Error('Rating family response mismatch');
            records.set(data.handle, {...data});
            data.handle = handle;
          }
          records.set(handle, data); resolve(data);
        } catch {
          // A lookup failure must never manufacture a score or block shopping.
          resolve({handle, market: null, count: 0, hop: null});
        } finally { active--; drain(); }
      })();
    }
  }
  function lookup(handle) {
    if (records.get(handle)?.commerce) return Promise.resolve(records.get(handle));
    if (!requests.has(handle)) requests.set(handle, new Promise(resolve => { pending.push({handle, resolve}); drain(); }));
    return requests.get(handle);
  }
  const visibility = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      visibility.unobserve(entry.target);
      const host = entry.target, slot = host.querySelector(':scope .hop-card-rating');
      if (!slot) continue;
      lookup(host.dataset.hopHandle).then(d => {
        if (!host.isConnected || host.dataset.hopHandle !== d.handle) return;
        paint(slot, d, host.matches('th')); decorate(host, d); scheduleAlignment();
      });
    }
  }, {rootMargin: '160px'});
  function attach(host) {
    const handle = handleOf(host);
    if (!handle) return;
    if (host.dataset.hopHandle === handle && host.querySelector('.hop-card-rating')) {
      hosts.add(host); if (records.has(handle)) decorate(host, records.get(handle));
      return;
    }
    // An outer wrapper must not acquire a second copy of its nested product card.
    if (host.querySelector('.ho-product-card')) return;
    const compare = host.matches('th');
    const heading = host.querySelector('.ho-kitchen-item-copy a') ||
      host.querySelector('h3,h2,h4,strong') ||
      host.querySelector('.ho-kitchen-item-copy a,a[href*="/products/"]');
    if (!heading) return;
    const ratingAnchor = heading.closest('.brand-card-heading') || (host.matches('.related-product') ? heading.parentElement : heading);
    if (compare) {
      heading.classList.add('hop-comparison-title');
      const table = host.closest('.ho-category-comparison-scroll table');
      if (table) table.style.setProperty('--hop-comparison-columns', host.parentElement.children.length);
    }
    host.dataset.hopHandle = handle; host.classList.add('hop-card-host'); hosts.add(host);
    host.querySelectorAll('.ho-product-rating').forEach(n => n.remove());
    let slot = host.querySelector('[data-hop-rating]');
    if (!slot) {
      slot = document.createElement('div'); slot.className = 'hop-card-rating'; slot.dataset.hopRating = '';
      ratingAnchor.after(slot);
    } else {
      if (slot.dataset.handle) readSlot(slot);
      if (slot.previousElementSibling !== ratingAnchor) ratingAnchor.after(slot);
    }
    slot.classList.toggle('hop-card-rating--compare', compare);
    const commerce = host.querySelector('[data-hop-commerce]');
    if (commerce) { try { const summary = JSON.parse(commerce.textContent); if(summary.handle === handle) records.set(handle, {...readSlot(slot), handle, commerce: summary}); } catch { /* invalid inline data */ } }
    if (records.has(handle)) { paint(slot, records.get(handle), compare); decorate(host, records.get(handle)); }
    if (!records.get(handle)?.commerce && isBrowsing(host)) visibility.observe(host);
    else if (!records.has(handle)) {
      paint(slot, {market:null,hop:null}, compare);
      visibility.observe(host);
    }
  }
  function scan(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(selectors)) attach(root);
    root.querySelectorAll(selectors).forEach(attach);
    scheduleAlignment();
  }
  function scheduleAlignment() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const groups = new Map();
      const layoutTop = el => { let top = 0; for (let node = el; node; node = node.offsetParent) top += node.offsetTop; return top; };
      for (const host of hosts) {
        if (!host.isConnected) { hosts.delete(host); continue; }
        host.querySelectorAll('.hop-aligned-track').forEach(n => { n.classList.remove('hop-aligned-track'); n.style.removeProperty('--hop-track-height'); });
        host.style.removeProperty('--hop-details-height');
      }
      for (const host of hosts) {
        if (!host.getClientRects().length) continue;
        const parent = host.parentElement.matches('article,[data-blackstone-item]') ? host.parentElement.parentElement : host.parentElement;
        if (!groups.has(parent)) groups.set(parent, new Map());
        const rows = groups.get(parent), row = layoutTop(host);
        if (!rows.has(row)) rows.set(row, []);
        rows.get(row).push(host);
      }
      for (const list of [...groups.values()].flatMap(rows => [...rows.values()])) {
        if (list.length < 2) continue;
        const compare = list[0].matches('th');
        const tracks = compare ? ['.hop-comparison-title', '.hop-card-rating', ':scope > p'] : ['.ho-home-eyebrow,.fm-eyebrow,.n-kicker', 'h2,h3,h4', '[data-hop-size]'];
        for (const selector of tracks) {
          const nodes = list.map(h => h.querySelector(selector)).filter(Boolean);
          const height = Math.max(0, ...nodes.map(n => n.getBoundingClientRect().height));
          nodes.forEach(n => { n.classList.add('hop-aligned-track'); n.style.setProperty('--hop-track-height', height + 'px'); });
        }
        // Share only the space actually used by ratings and options in this visual row.
        // No global blank ratings/options block and no fixed card or title height.
        if (!compare) {
          const sizes = list.map(h => h.querySelector('[data-hop-size]'));
          const tops = sizes.map((n,i) => n ? n.getBoundingClientRect().top - list[i].getBoundingClientRect().top + layoutTop(list[i]) : 0);
          const max = Math.max(0,...tops);
          list.forEach((h,i) => { if (sizes[i]) h.style.setProperty('--hop-details-height', Math.max(0,max-tops[i])+'px'); });
        }
      }
    });
  }
  const browsing = '.ho-product-card,.fm-card[data-fm-product],.n-card,.product-card,.brand-product-card,.bromic-stack,#ho-products .piece,#ho-hotspot .piece,.hx27-similar-item,.nap-related-card,.afd-related > a,.accessory-related,.related-product,.similar-card';
  const exact = '.hx27-addon,.afd-accessory,.accessory-card,.finishing-card,.space-project-item,.ho-kitchen-item,.accessory-grid > button,th';
  const optionsPath = document.querySelector('script[data-hop-options-url]')?.dataset.hopOptionsUrl;
  const optionsURL = optionsPath ? new URL(optionsPath, location.href).href : null;
  let optionData = null, optionRequest;
  function isBrowsing(host) {
    return host.matches(browsing) && !host.closest(exact) && !host.closest('[data-card-context="selection"]');
  }
  function loadOptions() {
    if (!optionsURL || optionRequest) return;
    optionRequest = fetch(optionsURL, {credentials:'same-origin'}).then(r => {if(!r.ok) throw Error();return r.json();}).then(data => {
      optionData = data;
      scan(document);
      for (const host of hosts) if(records.has(host.dataset.hopHandle)) decorate(host,records.get(host.dataset.hopHandle));
      scheduleAlignment();
    }).catch(() => { /* Native options remain usable when supplemental catalog data is unavailable. */ });
  }
  function owned(tag, cls) {
    const el = document.createElement(tag); el.className = cls; el.dataset.hopOwned = ''; return el;
  }
  function priceNode(host) {
    const known = host.querySelector('[data-hop-card-price],.ho-product-price,.n-card-price,.brand-card-price,.fm-card-price,.bromic-price');
    if (known) return known;
    return [...host.querySelectorAll('p,strong,b,span')].find(n => !n.closest('.hop-card-rating,[data-hop-options]') && !n.querySelector('p,strong,b,span') && /(?:[$£€¥]|USD|CAD)\s*[\d,.]+/.test(n.textContent));
  }
  function decorate(host, record) {
    if (!isBrowsing(host)) return;
    host.querySelectorAll('.hx27-similar-meta').forEach(node => node.remove());
    const inline = host.querySelector('[data-hop-commerce]');
    if (!record.commerce && inline) {
      try { const summary = JSON.parse(inline.textContent); if(summary.handle === record.handle) record.commerce = summary; } catch { /* fail closed */ }
    }
    const data = record.commerce;
    if (!data) return;
    loadOptions();
    // Normalize legacy bare recommendation markup to the existing shared card structure.
    if (host.matches('.ho-product-card') && host.closest('.hx27-similar-item') && !host.querySelector('.ho-product-card-copy')) {
      const photo = host.querySelector(':scope > img');
      if (photo) { const media = document.createElement('div'); media.className = 'ho-product-card-image'; photo.before(media); media.append(photo); }
      const copy = document.createElement('div'); copy.className = 'ho-product-card-copy';
      for (const child of [...host.children]) if (!child.matches('.ho-product-card-image')) copy.append(child);
      host.append(copy);
      if (data.vendor) { const brand = document.createElement('p'); brand.className = 'ho-home-eyebrow'; brand.textContent = data.vendor; copy.prepend(brand); }
    }
    const heading = host.querySelector('h3,h2,h4,strong');
    const rating = host.querySelector('[data-hop-rating]');
    if (!heading || !rating) return;
    host.classList.add('hop-browse-card');
    const body = host.querySelector('.ho-product-card-copy,.fm-card-body') || (host.matches('.brand-product-card,.related-product') ? host : heading.parentElement);
    body.classList.add('hop-card-body');
    const supplemental = optionData?.[record.handle];
    const colors = (supplemental?.colors?.length ? supplemental.colors : (data.colors || [])).map(color => ({...color, image: color.image || supplemental?.swatches?.[color.name.toLowerCase().replaceAll('gray','grey')]}));
    const sizes = Boolean(data.multipleSizes || supplemental?.multipleSizes);
    const signature = JSON.stringify([record.handle, colors, sizes, data.priceText]);
    const validPrice = !host.hasAttribute('data-hop-configured-price') && typeof data.priceText === 'string' && Number.isFinite(data.priceCents) && data.priceCents >= 0;
    if (host.dataset.hopSummary === signature && host.querySelector('[data-hop-size]') && (!validPrice || host.querySelector('[data-hop-card-price]')?.textContent === data.priceText)) return;
    host.dataset.hopSummary = signature;
    host.querySelectorAll('[data-hop-options],.ho-card-colors').forEach(n => n.remove());
    if (colors.length > 1) {
      const options = owned('div','hop-card-options'); options.dataset.hopOptions='';
      const swatches = owned('span','hop-card-swatches');
      const drawable = colors.filter(c => c.image || c.color).slice(0,3);
      for (const color of drawable) {
        const swatch = owned('span','hop-card-swatch'); swatch.title = color.name;
        if (color.image) {
          const img = document.createElement('img');
          try { const url = new URL(color.image, optionsURL || location.href); if (!['https:','http:'].includes(url.protocol)) continue; img.src=url.href; } catch {continue;}
          img.alt=color.name; img.width=24; img.height=24; img.loading='lazy'; swatch.append(img);
        } else {
          const chip = document.createElement('span'); chip.style.backgroundColor=color.color; chip.setAttribute('role','img'); chip.setAttribute('aria-label',color.name); swatch.append(chip);
        }
        swatches.append(swatch);
      }
      if (swatches.children.length) options.append(swatches);
      // With no verified swatch artwork, the product photo represents one choice.
      const remaining = colors.length - Math.max(1, swatches.children.length);
      if (remaining > 0) options.append(span('hop-card-other-colors','+'+remaining+' other '+(remaining===1?'color':'colors')));
      rating.after(options);
    }
    let price = priceNode(host);
    if (validPrice) {
      if (price?.hasAttribute('data-hop-card-price')) {
        if (price.textContent !== data.priceText) price.textContent = data.priceText;
      } else {
        const old = price;
        price = owned('p','ho-product-price hop-card-summary-price'); price.dataset.hopCardPrice=''; price.textContent=data.priceText;
        if (old) { old.classList.add('hop-card-original-price'); old.setAttribute('aria-hidden','true'); old.before(price); }
        else { const action = body.querySelector(':scope > .text-link'); if(action) action.before(price); else body.append(price); }
      }
    }
    let size = host.querySelector('[data-hop-size]');
    if (!size) { size = owned('div','hop-card-size'); size.dataset.hopSize=''; }
    size.textContent = sizes ? 'Multiple sizes available' : '';
    if (sizes) size.removeAttribute('aria-hidden'); else size.setAttribute('aria-hidden','true');
    if (price && price.previousElementSibling !== size) price.before(size);
    else if (!price && !size.isConnected) body.append(size);
    scheduleAlignment();
  }

  scan(document);
  document.fonts?.ready.then(scheduleAlignment);
  new MutationObserver(changes => {
    for (const change of changes) {
      if (change.target instanceof Element && (change.target.closest('.hop-card-rating') || (change.target.closest('[data-hop-owned]') && !change.target.closest('[data-hop-card-price]')))) continue;
      if (change.target instanceof Element) { const host = change.target.closest(selectors); if (host) attach(host); }
      if (change.type === 'attributes') { const host = change.target.closest(selectors); if(host) attach(host); continue; }
      for (const node of change.addedNodes) if (node instanceof Element && !node.matches('.hop-card-rating')) scan(node);
    }
  }).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['href','data-family-handle','data-hop-product-url']});
  let resize;
  window.addEventListener('resize', () => { clearTimeout(resize); resize = setTimeout(scheduleAlignment, 150); }, {passive:true});
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
